<template>
  <q-page class="column justify-center">
    <div class="row col-auto justify-center q-mb-lg">
      Stock list will include markup of <q-input style="width: 100px;" class="q-px-md" v-model="markupPerc" dense type="number" suffix="%"/>
    </div>
    <div class="row col-auto justify-center">
      <q-btn style="width: 50%;" class="col-auto" @click="downloadStockList">Download Stock List</q-btn>
    </div>
  </q-page>
</template>

<script>
import moment from 'moment'
import gql from 'graphql-tag'
import generateStockListAndDownload from '../../util/generateStockListAndDownload'
import adminNotifyError from '../../util/adminNotifyError'

export default {
  name: 'PageAdminStockOrders',
  apollo: {
    products () {
      return {
        query: gql`
          query products ($filter: ProductFilterInput) {
            products(filter: $filter, store: Stock) {
              products {
                id,
                name,
                attributes,
                reference,
                createdAt,
                updatedAt,
                images {
                  url
                  name
                },
                urlSlug,
                description,
                skus {
                  id,
                  showInContainer,
                  price,
                  options,
                  stock
                }
              }
            }
          }
        `,
        variables () {
          return {
            filter: {}
          }
        },
        update (result) {
          return result.products?.products
        },
        fetchPolicy: 'network-only'
      }
    }
  },
  methods: {
    fromNow (t) {
      if (!t) return '-'
      return moment(t).fromNow()
    },
    formatDate (d) {
      if (!d) return '-'
      return moment(d).format('DD/MM/YY')
    },
    async downloadStockList () {
      try {
        const products = await this.$apollo.query({
          query: gql`query products {
            products(filter: {}, store: Stock) {
              products {
                id,
                name,
                attributes,
                reference,
                images {
                  url
                  name
                },
                urlSlug,
                description,
                skus {
                  id,
                  showInContainer,
                  price,
                  options,
                  stock
                }
              }
            }
          }`,
          variables () {
            return {
              filter: {}
            }
          }
        })
        await generateStockListAndDownload(products.data.products.products, this.markupPerc)
      } catch (error) {
        adminNotifyError(this.$q, 'Failed to generate stock list.', error)
      }
    },
    uploadNewStock () {
      this.$router.push('/admin/add-stock')
    },
    async addNewProduct () {
      try {
        const response = await this.$apollo.mutate({
          mutation: gql`
            mutation addProduct($input: ProductInput!) {
                addProduct (input: $input) {
                    id
                }
            }
          `,
          variables: {
            input: {
              attributes: {
                manufacturer: '',
                type: '',
                brand: '',
                range: '',
                grip: '',
                material: '',
                size: '',
                holds: 0,
                bolts: '',
                screws: ''
              },
              description: '',
              images: [],
              reference: 'new-reference',
              name: 'New Product',
              urlSlug: 'update-this'
            }
          }
        })
        if (!response.data.addProduct) throw Error('Could not add product.')
        this.$router.push(`/admin/products/${response.data.addProduct.id}`)
      } catch (ex) {
        this.$q.notify({
          message: ex.message,
          color: 'negative',
          icon: 'report_problem'
        })
      }
    },
    deleteProduct (row) {
      const stockForProduct = row.skus.reduce((p, c) => p + c.stock, 0)
      if (stockForProduct) {
        this.$q.dialog({
          title: 'Delete Product',
          message: `You may not delete ${row.reference} as it has ${stockForProduct} items in stock.  Please remove all stock first.`
        })
        return
      }
      this.$q.dialog({
        title: 'Delete Product',
        message: `Are you sure you want to delete the product ${row.reference}? This cannot be undone.`,
        cancel: true
      }).onOk(async () => {
        try {
          await this.$apollo.mutate({
            mutation: gql`
            mutation deleteProduct($id: ID!) {
                deleteProduct (id: $id)
            }
          `,
            variables: {
              id: row.id
            }
          })
          await this.$apollo.queries.products.refetch()
        } catch (error) {
          adminNotifyError(this.$q, 'Error!', error)
        }
      })
    }
  },
  data () {
    return {
      filter: '',
      markupPerc: 10,
      pagination: {
        rowsPerPage: 20
      },
      columns: [
        { name: 'img' },
        { name: 'brand', required: true, label: 'Brand', align: 'left', field: row => row.attributes.brand, sortable: true },
        { name: 'reference', required: true, label: 'Reference', align: 'left', field: row => row.reference, sortable: true },
        { name: 'range', required: true, label: 'Range', align: 'left', field: row => row.attributes.range, sortable: true },
        { name: 'name', required: true, label: 'Name', align: 'left', field: row => row.name, sortable: true },
        { name: 'material', required: true, label: 'Material', align: 'left', field: row => row.attributes.material, sortable: true },
        { name: 'size', required: true, label: 'Size', align: 'left', field: row => row.attributes.size, sortable: true },
        { name: 'grip', required: true, label: 'Grip', align: 'left', field: row => row.attributes.grip, sortable: true },
        { name: 'holds', required: true, label: 'Holds', align: 'left', field: row => row.attributes.holds, sortable: true },
        { name: 'price', required: true, label: 'Price', align: 'left', field: row => Number(row.skus?.[0]?.price || 0), sortable: true },
        { name: 'skus', required: true, label: 'Skus', align: 'left', field: row => row.skus.length, sortable: true },
        { name: 'createdAt', required: true, label: 'Created', align: 'left', field: row => row.createdAt, sortable: true },
        { name: 'updatedAt', required: true, label: 'Updated', align: 'left', field: row => row.updatedAt, sortable: true },
        { name: 'actions', required: true, label: 'Actions', align: 'centre', sortable: false }
      ]
    }
  }
}
</script>
